import { FC } from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import './styles.scss';
import { Job } from '../JobsList/interfaces';
import { Link } from 'react-router-dom';

interface Props {
  onClose: () => void;
  jobsUsed: Job[];
  count: number;
}

const BASIC_WIDTH = 400;
const BASIC_HEIGHT = 350;

const FileInUseModal: FC<Props> = ({ onClose, jobsUsed, count }) => {
  return (
    <SpheraModal
      title="File in use"
      height={BASIC_HEIGHT}
      width={BASIC_WIDTH}
      onClose={onClose}
      actionText="Ok"
      onCancel={onClose}
      onAction={onClose}
    >
      <div className="jobs-used-list">
        <p className="jobs-used-list--title">The file is in use by {count} jobs:</p>
        <ul className="list">
          {jobsUsed.slice(0, 3).map((job) => (
            <li className="list-item" key={job.jobId}>
              <Link title={job.name} to={`/jobs/${job.jobId}`}>
                {job.name}
              </Link>
            </li>
          ))}
          {jobsUsed.length>3 && (<li className="list-item" key={'three-dots'}>...</li>)}
        </ul>
      </div>
    </SpheraModal>
  );
};

export default FileInUseModal;
